export default __webpack_public_path__ + "static/media/ProximaNova-Thin.e700c29b.otf";